/**
 * Every Marketo form the app submits to, by ID.
 *
 * These IDs are owned by marketing ops, not by us: they identify the form in
 * Marketo, key the server-side `marketo-form-submission-config` allow-list, and
 * key the `release-unified-form-submit` variation. A form ID written out at the
 * call site can gate one form and submit another, so they live here instead.
 *
 * Contact marketing ops before adding or changing an entry.
 */
export enum MarketoForm {
  /** "Contact sales" — product contact flows, routed by `cta_source`. */
  ContactSales = '1941',
  /** Sandbox email capture, shown before a visitor explores the demo. */
  SandboxRequest = '3144',
  /** Enterprise demo request on the signup page. */
  EnterpriseDemo = '3331',
}
